module.exports = __webpack_public_path__ + "static/img/20200809.0c42347.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/entry/20200809.png
// module id = 5E7C
// module chunks = 0